export const routes = {
  dashboard: '/',
  tasks: '/tasks',
  remoteConsultations: '/remote-consultations',
  members: '/members',
  member: '/members/:memberId',
  appointments: '/appointments',
  patients: '/patients',
  patient: '/patients/:patientId',
  checkout: '/checkout',
  dispensing: '/dispensing',
  inventory: '/inventory',
  productStock: '/inventory/:productId',
  schedule: '/schedule',
  admin: {
    staff: '/admin/staff',
    clinics: '/admin/clinics',
    catalogProducts: '/admin/catalog-products',
  },
} as const
